import { defineComponent as _defineComponent } from 'vue'
import 
TUIChatEngine,
{
  TUIGlobal,
  TUITranslateService,
  TUIConversationService,
  TUIGroupService,
  TUIStore,
  StoreName,
  IMessageModel,
  IConversationModel,
} from "@tencentcloud/chat-uikit-engine";
import { ref, onUnmounted, defineEmits } from "../../adapter-vue";
import ChatHeader from "./chat-header/index.vue";
import MessageList from "./message-list/index.vue";
import MessageInput from "./message-input/index.vue";
import MessageInputToolbar from "./message-input-toolbar/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["closeChat"],
  setup(__props, { emit: emits }) {


const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isUniFrameWork = ref(typeof uni !== 'undefined');
const isWeChat = ref(TUIGlobal.getPlatform() === "wechat");
const isToolbarShow = ref<boolean>(!isUniFrameWork.value);
const messageInputRef = ref();
const currentConversationID = ref();
// 是否显示群组管理
const isGroup = ref(false);
const groupID = ref("");

TUIStore.watch(StoreName.CONV, {
  currentConversationID: (id: string) => {
    currentConversationID.value = id;
  },
  currentConversation: (conversation: IConversationModel) => {
  isGroup.value = conversation?.type === TUIChatEngine.TYPES.CONV_GROUP;
  groupID.value = conversation?.groupProfile?.groupID;
 }
});

onUnmounted(() => {
  reset();
});

// 清空当前 conversationID
const reset = () => {
  TUIConversationService.switchConversation();
};

const closeChat = (conversationID: string) => {
  emits("closeChat", conversationID);
  reset();
};

const insertEmoji = (emojiObj: object) => {
  messageInputRef?.value?.insertEmoji(emojiObj);
};

const handleToolbarListShow = (show: boolean) => {
  if (isUniFrameWork.value) {
    isToolbarShow.value = show;
  } else {
    isToolbarShow.value = true;
  }
};
const handleEditor = (message: IMessageModel, type: string) => {
  if (!message || !type) return;
  switch (type) {
    case "reference":
      // todo
      break;
    case "reply":
      // todo
      break;
    case "reedit":
      if (message?.payload?.text) {
        messageInputRef?.value?.reEdit(message?.payload?.text);
      }
      break;
    default:
      break;
  }
};

const handleGroup = () => {
  TUIGroupService.switchGroup(groupID.value);
  uni.navigateTo({
    url: '/TUIKit/components/TUIGroup/manage-group/index',
  });
};

return { __sfc: true,emits, isPC, isUniFrameWork, isWeChat, isToolbarShow, messageInputRef, currentConversationID, isGroup, groupID, reset, closeChat, insertEmoji, handleToolbarListShow, handleEditor, handleGroup, TUITranslateService, ChatHeader, MessageList, MessageInput, MessageInputToolbar }
}

})